module.exports = __webpack_public_path__ + "img/product_desk_15.8e42f68c.jpg";